<!--this.Id = 0;
this.EventCustomRegFieldId = 0;
this.Value = "";
this.Descr = "";
this.Amount = 0;
this.UnitsAvailable = 0;
this.UnitsTaken = 0;-->
<ul class="list-inline stack-mobile wc-value-contianer">
  <li>
    <span class="wc-custom-field-dd-inline-block">
      <br /><button pButton type="button" class="btn btn-xs btn-danger" (click)="remove()" icon="pi pi-trash"></button>
    </span>
    <span class="wc-custom-field-dd-inline-block">
      {{ 'events.settings.registration-fields.value' | translate | titlecase }}
      <br /><input
        type="text"
        class="form-control wc-custom-field-dd-option wc-custom-field-dd-option-value"
        [(ngModel)]="availableValue.Value"
      />
    </span>
  </li>
  <li>
    {{ 'events.settings.registration-fields.description' | translate | titlecase }}
    <br /><input
      type="text"
      class="form-control wc-custom-field-dd-option wc-custom-field-dd-option-description"
      [(ngModel)]="availableValue.Descr"
    />
  </li>
  <li>
    {{ 'events.settings.registration-fields.additional-cost' | translate | titlecase }}
    <br /><input type="number" class="form-control wc-custom-field-dd-option" [(ngModel)]="availableValue.Amount" min="0" />
  </li>
  <li>
    {{ 'events.settings.registration-fields.unit-limit' | translate | titlecase }}
    <br /><input
      type="number"
      class="form-control wc-custom-field-dd-option"
      step="1"
      [(ngModel)]="availableValue.UnitsAvailable"
      min="0"
    />
  </li>
  <li [hidden]="availableValue.UnitsAvailable <= 0">
    {{ 'events.settings.registration-fields.units-remaining' | translate | titlecase }}
    <br />{{ availableValue.UnitsAvailable - availableValue.UnitsTaken }}
  </li>
</ul>
